import { useState } from 'react';

import { useHealthCheckQuery } from '@/features/health-check/api/check-health';
import ConnectionLost from '@/features/health-check/components/connection-lost';
import ConnectionRestored from '@/features/health-check/components/connection-restored';

import { Button } from '../ui/button';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '../ui/card';

const HealthLayout = ({ children }: { children: React.ReactNode }) => {
  const { failureCount } = useHealthCheckQuery();
  const [hadError, setHadError] = useState(false);

  if (!hadError && failureCount) setHadError(true);

  const showRecovery = hadError && !failureCount;
  const showError = !!failureCount || hadError;

  return (
    <>
      <div inert={!!failureCount}>{children}</div>
      {showError && (
        <div className="bg-card-foreground/20 fixed top-0 left-0 z-50 grid h-screen w-screen place-content-center">
          <Card className="relative w-full min-w-xs pt-0">
            <div className="flex h-32 justify-center bg-indigo-950">
              {showRecovery ? (
                <ConnectionRestored width="60%" className="relative top-1" />
              ) : (
                <ConnectionLost width="60%" className="relative top-1" />
              )}
            </div>
            <CardHeader>
              <CardTitle className="text-center">
                {showRecovery
                  ? 'Service is weer beschikbaar'
                  : 'Verbinding met de service mislukt'}
              </CardTitle>
              <CardDescription className="text-center">
                {showRecovery ? (
                  <>
                    De service is weer beschikbaar. U kunt nu weer gebruikmaken
                    van de website. Sluit deze melding of ververs de pagina.
                  </>
                ) : (
                  <>
                    Kan geen verbinding maken met de service. Probeer het later
                    opnieuw. Als dit probleem zich blijft voordoen, neem dan
                    contact op via{' '}
                    <a
                      href="mailto:support@valuechecker.ai"
                      className="text-blue-600 underline hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-500"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      support@valuechecker.ai
                    </a>
                    .
                  </>
                )}
              </CardDescription>
            </CardHeader>
            {showRecovery && (
              <CardFooter className="grid grid-cols-2 gap-2">
                <Button variant="outline" onClick={() => setHadError(false)}>
                  Sluiten
                </Button>
                <Button onClick={() => window.location.reload()}>
                  Opnieuw laden
                </Button>
              </CardFooter>
            )}
          </Card>
        </div>
      )}
    </>
  );
};

export default HealthLayout;
